import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UpcomingTestService {

  private cachedVersion: string | null = null;
  private isChecking = false;

  // null initially instead of {}
private upcomingTestsSource = new BehaviorSubject<any>({
  scheduled_tests: []
});

  upcomingTests$ = this.upcomingTestsSource.asObservable();

  private originalData: any = {};

  private intervalId: any;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private ngZone: NgZone
  ) { }

  // =========================
  // INITIAL LOAD
  // =========================

  initUpcomingTests() {

    // first direct load
    this.fetchUpcomingTests();

    // setup listeners
    this.setupEventListeners();
  }

  // =========================
  // GET TEST DETAILS
  // =========================

  testDetails(): Observable<any> {

    return this.http.get<any>(
      `${environment.userHost}/test_details/${this.cookieService.get('_PAOID')}`
    );
  }

  // =========================
  // FILTER TESTS
  // =========================

  private filterScheduledTests(data: any): any[] {

    if (
      !data ||
      !data.scheduled_tests ||
      data.scheduled_tests.length === 0
    ) {
      return [];
    }

    const arr = [];

    data.scheduled_tests.forEach((value: any) => {

      if (
        (value.Test_Status === 1 || value.Test_Status === 6) &&
        value.active_index === 'n'
      ) {

        arr.push(value);

      } else if (
        (
          value.Test_Status === 2 ||
          value.Test_Status_Name === 'Paused' ||
          value.Test_Status_Name === 'On-going'
        ) &&
        value.active_index === 'n'
      ) {

        arr.push(value);
      }

    });

    return arr;
  }

  // =========================
  // SAVE SAFE BROWSER DOWNLOAD
  // =========================

  saveUserBrowserDownload(
    schedule_instance_id,
    user_id,
    org_id
  ): Observable<any> {

    return this.http.get<any>(
      `${environment.userHost}/storeSafeBrowserDownload/${org_id}/${schedule_instance_id}/${user_id}/web`
    );
  }

  // =========================
  // VERSION CHECK
  // =========================

  checkVersion() {

    if (this.isChecking) {
      return;
    }

    this.isChecking = true;

    this.http
      .get<any>(
        `${environment.userHost}/tests_version/${this.cookieService.get('_PAOID')}`
      )
      .subscribe(

        (response) => {

          const serverVersion = response.upcomingTestsVersion;

          // first time OR changed
          if (
            this.cachedVersion === null ||
            this.cachedVersion !== serverVersion
          ) {

            this.cachedVersion = serverVersion;

            this.fetchUpcomingTests();
          }

          this.isChecking = false;
        },

        (error) => {

          console.error('Version check failed:', error);

          this.isChecking = false;
        }
      );
  }

  // =========================
  // FETCH TESTS
  // =========================

  fetchUpcomingTests() {

    this.http
      .get<any>(`${environment.userHost}/test_details/${this.cookieService.get('_PAOID')}`
      )
      .subscribe(

        (response) => {

          this.originalData = response;

          // force angular update in SEB
          this.ngZone.run(() => {

            this.upcomingTestsSource.next(this.originalData);

          });

        },

        (error) => {

          console.error('Fetch upcoming tests failed:', error);
        }
      );
  }

  // =========================
  // EVENT LISTENERS
  // =========================

  private setupEventListeners() {

    // immediate version check
    this.checkVersion();

    // tab focus
    window.addEventListener('focus', () => {

      this.checkVersion();

    });

    // network reconnect
    window.addEventListener('online', () => {

      this.checkVersion();

    });

    // fallback polling
    this.intervalId = setInterval(() => {

      if (document.visibilityState === 'visible') {

        this.checkVersion();

      }

    }, 120000);
  }

  // =========================
  // CLEANUP
  // =========================

  destroyListeners() {

    if (this.intervalId) {

      clearInterval(this.intervalId);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/application/services/api-service/upcoming-test.service.ts